import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const HIDE_CHROME = ["/login", "/register", "/forgot-password", "/reset-password", "/admin"];

export default function Layout() {
  const location = useLocation();
  const hideChrome = HIDE_CHROME.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {!hideChrome && <Navbar />}
      <main className={hideChrome ? "" : "pt-[6.5rem]"}>
        <Outlet />
      </main>
      {!hideChrome && <Footer />}
      {!hideChrome && <WhatsAppFloat />}
    </>
  );
}
